import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchBranch = (page_no ,filter, limit = DEFAULT_TOTAL_RECORDS ) => {
    return axiosInstance.get(EndPoints.BRANCH.LIST,{
        params:{
            limit,
            page_no,
            zone_id,
            ...filter
            // total_count:totalItems
        }
    });
}

export const createBranch = (payload) => {
    return axiosInstance.post(EndPoints.BRANCH.CREATE, payload)
}

export const updateBranch = (payload) => {
    return axiosInstance.put(EndPoints.BRANCH.UPDATE, payload)
}


export const deleteBranch = (payload) => {
    const url = EndPoints.BRANCH.DELETE  + `/${payload}` 
    return axiosInstance.delete(url)
}

export const downloadCSV = () => {
    return axiosInstance.put(EndPoints.BRANCH.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}